<template>
  <Content nav="true" admin="true">
    <h1>News</h1>
    <form class="pure-form">
      <fieldset>
        <div class="pure-controls">
          <textarea v-model="message" rows="2"></textarea>
        </div>
      </fieldset>
      <fieldset>
        <div class="pure-controls">
          <button @click.prevent="save" :disabled="saving" class="pure-button pure-button-primary">
            <font-awesome-icon icon="save"/>&nbsp; Save
          </button>
        </div>
      </fieldset>
    </form>
  </Content>
</template>

<script>
import Session from '@/mixins/Session.js'

export default {
  name: 'News',
  mixins: [Session],
  beforeMount() {
    this.authorize()
  },
  data() {
    return {
      message: '',
      saving: false
    }
  },
  methods: {
    getMessage() {
      this.$database
        .collection('news')
        .doc('alert')
        .get()
        .then(result => (this.message = result.data().message))
    },
    formatMessage() {
      this.message = this.message.trim()
    },
    save() {
      this.formatMessage()
      this.saving = true
      this.$database
        .collection('news')
        .doc('alert')
        .set({ message: this.message })
        .then(() => (this.saving = false))
    }
  },
  mounted() {
    this.getMessage()
  }
}
</script>

<style lang="less" scoped>
textarea {
  width: 100%;
}
</style>
